import { z } from "zod"
import { apiResponseSchema, paginatedResponseSchema } from "./shared"
import { providerSchema } from "./provider"

const customerSchema = z
  .object({
    _id: z.string().optional(),
    name: z.string().optional(),
    email: z.string().optional(),
    image: z.string().optional(),
  })
  .passthrough()

const serviceRefSchema = z
  .object({
    _id: z.string().optional(),
    name: z.string().optional(),
  })
  .passthrough()

export const appointmentSchema = z
  .object({
    _id: z.string().optional().nullable(),
    appointmentId: z.string().optional().nullable(),
    customer: customerSchema.optional().nullable(),
    service: serviceRefSchema.optional().nullable(),
    serviceProvider: z.union([z.string(), providerSchema]).optional().nullable(),
    status: z.string().optional().nullable(),
    appointmentStartTime: z.string().optional().nullable(),
    appointmentEndTime: z.string().optional().nullable(),
    rating: z.number().optional().nullable(),
    unitName: z.string().optional().nullable(),
    review: z
      .object({
        rating: z.number().optional().nullable(),
      })
      .passthrough()
      .optional()
      .nullable(),
  })
  .passthrough()

export const appointmentResponseSchema = apiResponseSchema(appointmentSchema)
export const appointmentsResponseSchema = paginatedResponseSchema(appointmentSchema)
